export default __webpack_public_path__ + "static/media/work-revert.ced69bd2.svg";